export const HorizontalDoubleArrowIcon = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <svg
      width="27"
      height="12"
      viewBox="0 0 27 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.40018 4.56825H22.0488L19.7084 2.18138C19.4477 1.92663 19.3173 1.62825 19.3173 1.28625C19.3173 0.944501 19.4447 0.646126 19.6994 0.391126C19.9544 0.130376 20.2528 0 20.5946 0C20.9366 0 21.2379 0.130376 21.4987 0.391126L26.0493 4.94175C26.1863 5.07875 26.2858 5.22175 26.3478 5.37075C26.4096 5.5195 26.4404 5.67788 26.4404 5.84588C26.4404 6.01388 26.4096 6.17225 26.3478 6.321C26.2858 6.47 26.1863 6.613 26.0493 6.75L21.4897 11.3096C21.2349 11.5644 20.9351 11.6918 20.5901 11.6918C20.2453 11.6918 19.9454 11.5614 19.6904 11.3006C19.4357 11.0456 19.3083 10.741 19.3083 10.3868C19.3083 10.0323 19.4357 9.73063 19.6904 9.48188L22.0488 7.1235H4.40018L6.74093 9.51938C6.97668 9.77413 7.0993 10.0725 7.1088 10.4145C7.1183 10.7563 6.99568 11.0546 6.74093 11.3096C6.48593 11.5644 6.18756 11.6918 5.84581 11.6918C5.50381 11.6918 5.20543 11.5644 4.95068 11.3096L0.391054 6.75C0.254055 6.613 0.154554 6.47 0.0925541 6.321C0.0308037 6.17225 -7.05719e-05 6.01388 -7.05719e-05 5.84588C-7.05719e-05 5.67788 0.0308037 5.5195 0.0925541 5.37075C0.154554 5.22175 0.254055 5.07875 0.391054 4.94175L4.95068 0.391126C5.20543 0.136376 5.50381 0.00900078 5.84581 0.00900078C6.18756 0.00900078 6.48593 0.136376 6.74093 0.391126C7.00168 0.646126 7.1258 0.943001 7.1133 1.28175C7.1008 1.62075 6.97668 1.92063 6.74093 2.18138L4.40018 4.56825Z"
        fill="currentColor"
      />
    </svg>
  );
};
